import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../service/login/login.service';
import { Router, ActivatedRoute } from "@angular/router";
import { LeafletService } from "../../ng-leaflet/services/leaflet.service";
import { UUID } from "angular2-uuid";

@Component({
  selector: 'app-contact-ways',
  templateUrl: './contact-ways.component.html',
  styleUrls: ['./contact-ways.component.css'],
  providers: [LeafletService]
})
export class ContactWaysComponent implements OnInit {
  type = '联系方式'
  news: any = []

  public leafletOptions: any;
  shutterMapId = UUID.UUID();
  shutterMap;
  shutterLayerControl;

  constructor(private service: LoginService, private leafletService: LeafletService, private router: Router) { }

  getInfo() {
    this.service.getNews(this.type).subscribe((res: any) => {
      this.news = res['result']
    })
  }
  detail(e) {
    console.log('我看下这个能不能获取到id', e)
    localStorage.setItem('detailtit', e.title)
    localStorage.setItem('detailtime', e.time)
    localStorage.setItem('detailcontent', e.content)
    localStorage.setItem('detailImg', e.fileid)
    this.router.navigate(['/detail'])
  }
  ngOnInit() {
    this.getInfo(),
      // 初始化地图
      this.leafletOptions = {
        center: [36.04933, 103.86035],
        minZoom: 2,
        maxZoom: 17,
        zoom: 8,
        layersControl: false,
        measureCtl: false,
        zoomControl: false,
        defaultExtentControl: false,
        baseLayer: false,
        attributionControl: false,

      };

    setTimeout(() => {
      this.shutterMap = L.map(
        document.getElementById(this.shutterMapId),
        this.leafletOptions
      );

      // 初始化图层底图
      // const layers = this.initBaseLayers(this.shutterMap);
      // this.shutterLayerControl = L.control
      //   .layers({}, {}, { collapsed: false })
      //   .addTo(this.shutterMap);

      // const vectorMap = L.tileLayer.chinaProvider("TianDiTu.Normal.Map", {
      //   maxZoom: 18
      // });
      // const vectorAnn = L.tileLayer.chinaProvider("TianDiTu.Normal.Annotion", {});

      const vectorMap = L.tileLayer.chinaProvider('GaoDe.Normal.Map', {
        maxZoom: 18,
        minZoom: 5
      });
      const vectorAnn = L.tileLayer.chinaProvider("GaoDe.Satellite.Annotion", {});
      const vecGroup = L.layerGroup([vectorMap, vectorAnn]);

      vecGroup.addTo(this.shutterMap)

      var markerIcon = L.AwesomeMarkers.icon({
        icon: "fire",
        prefix: "fa",
        markerColor: "red"
      });

      var marker = L.marker([Number(36.04933), Number(103.86035)], { icon: markerIcon })
        .addTo(this.shutterMap)
        .bindPopup("高分甘肃中心")
        .openPopup();

      this.shutterMap.setView(marker.getLatLng(), 16);

    }, 100);

  }
}

